import { StateCreator } from "zustand";

import { LOGOUT_URL } from "@/data/auth";

import { AppState, AuthSlice, Mutators } from "./types";

export const createAuthSlice: StateCreator<
  AppState,
  Mutators,
  [],
  AuthSlice
> = (set, get) => ({
  authToken: null,
  session: null,
  logIn: (authToken) => {
    set({ authToken });
  },
  logOut: () => {
    const sessionId = get().session?.session_id;

    set({ authToken: null, session: null });
    window.localStorage.removeItem("token");

    if (sessionId) {
      window.location.href = LOGOUT_URL + sessionId;
    } else {
      window.location.href = "/";
    }
  },

  setSession: (session) => {
    set({ session });
  },
});
